import BankAccountCell from './BankAccountCell';

export default BankAccountCell;
